// src/wbr/components/MainContent.js
import React from "react";
import CoverPage from "./coverpage/CoverPage";
import ActionTracker from "./action_tracker/ActionTracker";
import BusinessUpdates from "./business_updates/BusinessUpdates";
import Report from "./reports/ReportPage";
import AdminPage from "./admin/AdminPageV2";
import UploadPage from "./upload/UploadPage";
import pulseai from "./pulseai/pulseai";
import AllInOne from "./AllInOne/AllInOne";

const CONTENT_COMPONENTS = {
  coverpage: CoverPage,
  actiontracker: ActionTracker,
  businessupdates: BusinessUpdates,
  report: Report,
  pulseai:pulseai,
  allinone: AllInOne,
};

function MainContent({
  theme,
  function_id,
  week,
  userLogin,
  year,
  activeItem,
  functionConfig,
  viewMode = "content",
}) {
  // ─── Admin View ───
  if (viewMode === "admin") {
    return (
      <div className="main-content-area">
        <AdminPage
          theme={theme}
          functionId={function_id}
          week={week}
          year={year}
          functionConfig={functionConfig}
        />
      </div>
    );
  }

  // ─── Upload View ───
  if (viewMode === "upload") {
    return (
      <div className="main-content-area">
        <UploadPage
          theme={theme}
          function_id={function_id}
          week={week}
          year={year}
          functionConfig={functionConfig}
        />
      </div>
    );
  }

  // ─── Default: CoverPage ───
  if (!activeItem) {
    return (
      <div className="main-content-area">
        <CoverPage
          theme={theme}
          functionId={function_id}
          week={week}
          year={year}
          itemKey="coverpage"
          label="Cover Page"
          buttonText=""
          functionConfig={functionConfig}
        />
      </div>
    );
  }

  // ─── Normal content ───
  const ContentComponent = CONTENT_COMPONENTS[activeItem.type];

  if (!ContentComponent) {
    return (
      <div className="main-content-area">
        <p>
          In progress (coming Soon): <strong>{activeItem.type}</strong>
        </p>
      </div>
    );
  }
  return (
    <div className="main-content-area">
      <ContentComponent
        theme={theme}
        functionId={function_id}
        week={week}
        year={year}
        itemKey={activeItem.key}
        label={activeItem.label}
        buttonText={activeItem.buttonText}
        functionConfig={functionConfig}
        userLogin={userLogin}
      />
    </div>
  );
}

export default MainContent;